$(function () {
  $('a[href="/logout"]').on("click", function () {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  });

  $("#to-new-interface").on("click", function () {
    localStorage.setItem("newInterface", "true");
  });

  $(".company-change-list-item").on('click', () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  })

  // if (
  //   !!localStorage.getItem("newInterface") &&
  //   (window.location.pathname.startsWith("/ftasks") ||
  //     window.location.pathname.startsWith("/tasks")) &&
  //   !window.location.pathname.includes("/new/")
  // ) {
  //   window.open("/new/tasks/", "_self");
  // }

  // if (
  //   window.location.pathname.includes("/new/") ||
  //   !!localStorage.getItem("newInterface")
  // ) {
  //   $("#left-panel-nav a[href^='/tasks/']").each(function () {
  //     this.href = "/new" + this.href.replace(location.origin, "");
  //   });
  //   $("#left-panel-nav a[href^='/ftasks/']").each(function (e) {
  //     this.href =
  //       "/new" +
  //       this.href.replace("ftasks", "tasks").replace(location.origin, "");
  //   });
  // }

  if (location.pathname.includes('register-company')) {
    const userIdEl = document.getElementById('userId');
    const userId = userIdEl ? userIdEl.content : '';

    if (!!userId) {
      try {
        window.dataLayer.push({
          event: 'comp_cabinet_about_pageview',
          user_id: userId
        });
      } catch (_) {}
    }
  }

  if (location.pathname.includes('ftasks')) {
    const userIdEl = document.getElementById('userId');
    const userId = userIdEl ? userIdEl.content : '';

    if (!!userId) {
      try {
        window.dataLayer.push({
          event: 'comp_cabinet_tasks_pageview',
          user_id: userId
        });
      } catch (_) {}
    }
  }

  var animationProgress = false;

  let pressedButtons = [];

  function showLoader(element) {
    if (pressedButtons.includes(element)) {
      return false;
    }
    pressedButtons.push(element);

    element.addClass("loading-bg");

    return true;
  }

  function hideLoader(element) {
    if (pressedButtons.includes(element)) {
      pressedButtons = pressedButtons.filter(function (e) {
        return e !== element;
      });
    }
    element.removeClass("loading-bg");
  }

  $("select.select2").each(function () {
    let $select = $(this),
        width = $select.attr("data-select-width") || "100%";

    $select.select2({ allowClear: true, width: width });

    $select.closest('.input-group').on('click', '.clear-field', function () {
      const $inputGroup = $(this).closest('.input-group');
      const $selectField = $inputGroup.find('select');
      const $hiddenField = $inputGroup.find('input[type="hidden"]');

      $selectField.val(null).trigger('change');

      if ($hiddenField.length) {
        $hiddenField.val('');
      }
    });

    $select.on('change', function () {
      const $inputGroup = $select.closest('.input-group');
      const $hiddenField = $inputGroup.find('input[type="hidden"]');

      if ($hiddenField.length) {
        $hiddenField.val($select.val());
      }
    });
  });
  $(".datepicker").each(function () {
    var elem = $(this);
    elem.datepicker({
      autoclose: true,
      zIndexOffset: 99999,
      format: elem.attr("data-date-dateformat") || "dd.mm.yyyy",
      container: elem.attr("data-container") || "body",
      startDate: elem.attr("data-start-date"),
      startView: getViewId(elem.attr("data-date-start-view") || "days"),
      minViewMode: getViewId(elem.attr("data-date-min-view-mode") || "days"),
      maxViewMode: getViewId(elem.attr("data-date-max-view-mode") || "decade"),
      language: getLocale(),
      templates: {
        leftArrow: '<i class="fas fa-chevron-left"></i>',
        rightArrow: '<i class="fas fa-chevron-right"></i>',
      },
    });
  });

  if (localStorage) {
    let amounts = [];
    let currencies = [];
    animationTimer = 15000;
    const balancesStorageName = "balances";
    $(".freelancer-balance .amount")
      .slice(3)
      .each(function () {
        amounts.push($(this).get(0).innerText.replace(/\s+/g, ""));
      });
    $(".freelancer-balance .currency")
      .slice(3)
      .each(function () {
        currencies.push($(this).get(0).innerText);
      });

    let balances = {};

    currencies.forEach(function (item, index) {
      balances[item] = parseFloat(amounts[index]);
    });

    const oldBalances = JSON.parse(localStorage.getItem(balancesStorageName));
    if (
      oldBalances &&
      Object.keys(balances).some((key) => balances[key] > oldBalances[key])
    ) {
      $(".blink-icon").css("display", "inline-flex");
      localStorage.setItem(balancesStorageName, JSON.stringify(balances));
      setTimeout(function () {
        $(".blink-icon").css("display", "none");
      }, animationTimer);
    } else {
      localStorage.setItem(balancesStorageName, JSON.stringify(balances));
    }
  }

  function getLocale() {
    const localeMeta = document
      .querySelector('meta[name="language"]')
      .getAttribute("content");
    return localeMeta ? localeMeta : "ru";
  }

  function getViewId(viewName) {
    switch (viewName) {
      case "days":
      case "month":
        return 0;
        break;
      case "months":
      case "year":
        return 1;
        break;
      case "years":
      case "decade":
        return 2;
        break;
      case "decades":
      case "century":
        return 3;
        break;
      default:
        return 0;
        break;
    }
  }

  $(".utc-datetime").each(function (_, el) {
    parseUTCDateTime(el);
  });
  $(".utc-date").each(function (_, el) {
    parseUTCDate(el);
  });

  $(".datetime").each(function (_, el) {
    parseDateTime(el);
  });
  $(".date").each(function (_, el) {
    parseDate(el);
  });

  let workingDate = false;
  let workingDateTime = false;
  let workingDateWithoutUTC = false;
  let workingDateTimeWithoutUTC = false;
  const observer = new MutationObserver(mutationList =>
      mutationList.filter(m => m.type === 'childList').forEach(m => {
        m.addedNodes.forEach(function() {
          if ($(".utc-date").not(".utc-done").length && !workingDate) {
            workingDate = true;
            $(".utc-date")
                .not(".utc-done")
                .each(function (_, el) {
                  parseUTCDate(el);
                })
                .promise()
                .done(() => (workingDate = false));
          }
          if ($(".utc-datetime").not(".utc-done").length && !workingDateTime) {
            workingDateTime = true;
            $(".utc-datetime")
                .not(".utc-done")
                .each(function (_, el) {
                  parseUTCDateTime(el);
                })
                .promise()
                .done(() => (workingDateTime = false));
          }
          if (
              $(".datetime").not(".datetime-done").length &&
              !workingDateTimeWithoutUTC
          ) {
            workingDateTimeWithoutUTC = true;
            $(".datetime")
                .not(".datetime-done")
                .each(function (_, el) {
                  parseDateTime(el);
                })
                .promise()
                .done(() => (workingDateTimeWithoutUTC = false));
          }
          if ($(".date").not(".date-done").length && !workingDateWithoutUTC) {
            workingDateWithoutUTC = true;
            $(".date")
                .not(".date-done")
                .each(function (_, el) {
                  parseDate(el);
                })
                .promise()
                .done(() => (workingDateWithoutUTC = false));
          }
        });
      }));
  observer.observe(document.body,{childList: true, subtree: true});

  function parseUTCDate(el) {
    const value = parseInt(el.innerHTML) * 1000;
    if (!isNaN(value)) {
      el.classList.add("utc-done");
      el.innerHTML = formatDate(value, true);
    }
  }

  function parseDate(el) {
    const value = parseInt(el.innerHTML) * 1000;
    if (!isNaN(value)) {
      el.classList.add("date-done");
      el.innerHTML = formatDate(value);
    }
  }

  function parseDateTime(el) {
    const value = parseInt(el.innerHTML) * 1000;
    if (!isNaN(value)) {
      el.classList.add("datetime-done");
      el.innerHTML = formatDateTime(value);
    }
  }

  function parseUTCDateTime(el) {
    const value = parseInt(el.innerHTML) * 1000;
    if (!isNaN(value)) {
      el.classList.add("utc-done");
      el.innerHTML = formatDateTime(value, true);
    }
  }

  function formatDate(date, withUTC = false) {
    const resLocalDate = new Date(date);
    const resUTCDate = new Date(
      new Date(date).setMinutes(
        resLocalDate.getMinutes() + resLocalDate.getTimezoneOffset()
      )
    );
    if (withUTC) {
      return `${getDateTime(resUTCDate, false)} UTC (${getDateTime(
        resLocalDate,
        false
      )} local time)`;
    }
    return getDateTime(resLocalDate, false);
  }

  function formatDateTime(date, withUTC = false) {
    const resLocalDate = new Date(date);
    const resUTCDate = new Date(
      new Date(date).setMinutes(
        resLocalDate.getMinutes() + resLocalDate.getTimezoneOffset()
      )
    );
    if (withUTC) {
      return `${getDateTime(resUTCDate)} UTC (${getDateTime(
        resLocalDate
      )} local time)`;
    }
    return getDateTime(resLocalDate);
  }

  function getDateTime(currentDate, withTime = true) {
    var date =
      currentDate.getDate() +
      "." +
      ("0" + (currentDate.getMonth() + 1)).substr(-2) +
      "." +
      currentDate.getFullYear();
    var currentHours = ("0" + currentDate.getHours()).substr(-2);
    var currentMins = ("0" + currentDate.getMinutes()).substr(-2);
    var time = currentHours + ":" + currentMins;
    var dateTime = withTime ? `${date} ${time}` : date;
    return dateTime;
  }

  function isValidDate(date) {
    return (
      date &&
      Object.prototype.toString.call(date) === "[object Date]" &&
      !isNaN(date)
    );
  }

  function viewWarningAlert(message) {
    $.smallBox({
      title: translate.payment_caption,
      content: message,
      color: "#C46A69",
      timeout: 1000,
      icon: "fa fa-warning shake animated",
    });
  }

  function viewWarningCommonAlert(message) {
    $.smallBox({
      title: translate.alert_danger_caption,
      content: message,
      color: "#C46A69",
      timeout: 1000,
      icon: "fa fa-warning shake animated",
    });
  }

  $('[data-toggle="popover-lg"]').popover({
    animation: true,
    trigger: "hover",
    template:
      '<div class="popover popover-lg" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
  });

  $('[data-toggle="popover-notifications"]').popover({
    html: true,
    animation: true,
    placement: "right",
    template:
      '<div class="popover sr-popover-notifications" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
  });

  $('[data-toggle="popover-notifications"]').on(
    "shown.bs.popover",
    function () {
      Cookies.set("popover-notifications", $(this).attr("data-hash"));
    }
  );

  if (
    Cookies.get("popover-notifications") !=
      $('[data-toggle="popover-notifications"]').attr("data-hash") &&
    window.innerWidth > 980
  ) {
    $('[data-toggle="popover-notifications"]').popover("show");
  }

  if ($('[data-toggle="popover-notifications"]').data("isfreelancer") != "1") {
    setTimeout(function () {
      if (!Cookies.get("popover-notifications")) {
        $('[data-toggle="popover-notifications"]').popover("hide");
      }
    }, 10000);
  }

  $(document).on("click", function (e) {
    if (
      !$(e.target).is(
        $(
          '[data-toggle="popover-notifications"], [data-toggle="popover-notifications"] i, .menu-item-parent, .badge, .popover-title, .popover-content'
        )
      ) && (e.target.id !== 'confirmEmailLink') && (e.target.id !== 'confirmEmailLink_fail')) {
      $('[data-toggle="popover-notifications"]').popover("hide");
    } else if (e.target.id === 'confirmEmailLink' || e.target.id === 'confirmEmailLink_fail'){
      $('#confirmEmailLink').css('display', 'none');
      $('#confirmEmailLink_pending').css('display', 'block');
      $.ajax({
        url: "/api/profile/init-email-verification",
        type: "POST",
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('accessToken')
        },
      }).done(function (response) {
        $('#confirmEmailLink_pending').css('display', 'none');
        $('#confirmEmailLink_success').css('display', 'block');
      }).error(function (error) {
        $('#confirmEmailLink_pending').css('display', 'none');
        $('#confirmEmailLink_fail').css('display', 'block');
      });
    }
  });

  $(".with-accept").on("mousedown", function (event) {
    var that = $(this);
    $.SmartMessageBox(
      {
        title: "Изменение данных",
        content: "Вы уверены что хотите совершить это действие?",
        buttons: "[Нет][Да]",
      },
      function (ButtonPressed) {
        if (ButtonPressed === "Да") {
          that.click();
        }
      }
    );
  });

  $(".main-page .main-menu li").on("mouseover", function () {
    $(".main-menu li").each(function () {
      $(this).removeClass("active");
    });
  });

  $(".main-page .main-menu li").on("mouseout", function () {
    $(".current").addClass("active");
  });

  changePage(location.hash);

  $(window).bind("hashchange", function (e) {
    changePage(location.hash);
  });

  $(".main-page .main-menu li, .change-page").on("click", function (event) {
    var block = $(this).data("block");
    var title = $(this).data("title");

    if (!animationProgress) {
      animationProgress = true;
      document.title = "Solar-staff.com :: " + title;
      changePage(block);
    }
  });

  function changePage(hash) {
    var id;

    if (hash !== "" && hash.substr(0, 1) !== "#") {
      hash = "#" + hash;
    }

    if (hash === "" || hash === "#") {
      id = ".why";
    } else {
      id = "." + hash.substr(1);
    }

    if ($(id + "-block").length) {
      if ($(".viewed").length) {
        $(".viewed").fadeTo(300, 0, function () {
          $(this).hide(function () {
            $(id + "-block").fadeTo(300, 1, function () {
              $(this).show(100, function () {
                $(".nav-body").removeClass("viewed");
                $(id + "-block").addClass("viewed");
                animationProgress = false;
              });
            });
          });
        });
      } else {
        $(id + "-block").fadeTo("slow", 1);
        $(".nav-body").removeClass("viewed");
        $(id + "-block").addClass("viewed");
      }
    }

    $(".main-menu li").removeClass("active, current");
    $("#" + id.substr(1) + "-menu")
      .addClass("active")
      .addClass("current");

    if (location.hash !== hash) {
      location.hash = hash;
    }
  }

  $(".default_datepicker").datepicker({
    minDate: new Date("-1y"),
    dateFormat: "dd.mm.yy",
  });

  $(".empty_datepicker").datepicker({
    dateFormat: "dd.mm.yy",
  });

  $(".buttons a").on("click", function (event) {
    event.preventDefault();

    var block = $(this).attr("href").split("#")[1];
    $(".content-block").addClass("hidden");
    $("#" + block).removeClass("hidden", { duration: 200 });
  });

  $(".calculator-amount").on("change keyup focus", function () {
    if (this.value.match(/[^0-9]/g)) {
      this.value = this.value.replace(/[^0-9]/g, "");
    }

    if (this.value.length > 7) {
      this.value = this.value.substring(0, 7);
    }

    var amount = parseInt($(this).val());
    var ndfl = 0;
    var social = 0;
    var commission = 0;
    var all_common = 0;
    var all_solar = 0;

    $(".calculator-dublicate").text(amount);
    if (amount > 0) {
      ndfl = parseFloat((amount * 0.15).toFixed(2));
      social = parseFloat((amount * 0.46).toFixed(2));
      commission = parseFloat((amount * 0.12).toFixed(2));

      all_common = parseFloat((amount + ndfl + social).toFixed(2));
      all_solar = parseFloat((amount + commission).toFixed(2));
    }

    $(".ndfl").text(ndfl);
    $(".social").text(social);
    $(".commission").text(commission);
    $(".all-common").text(all_common);
    $(".all-solar").text(all_solar);
  });

  $("#hide-menu").on("click", ".navbar-toggle", function (event) {
    if ($("body").hasClass("hidden-menu")) {
      $("body").removeClass("hidden-menu");
    } else {
      $("body").addClass("hidden-menu");
    }
  });

  function isValidPhone(phone) {
    return /^\+\d{6,17}$/.test(phone);
  }

  function isValidEmail(email, strict) {
    if (!strict) {
      email = email.replace(/^\s+|\s+$/g, "");
    }
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
      email
    );
  }

  function sendInvitePhone(phone, customer, reply, inEnglish, note, managerIds) {
    $.ajax({
      url: "/ajax/sendInvite",
      type: "POST",
      data: {
        YII_CSRF_TOKEN: token,
        phone: phone,
        customer: customer,
        reply: reply,
        inEnglish: inEnglish,
        note: note,
        managerIds: managerIds,
      },
    }).done(function (response) {
      response = JSON.parse(response);
      if (response.code == 0) {
        if (response.response.length) {
          location.href = response.response;
        } else {
          location.href = "/freelancers";
        }
      } else {
        location.href = "/freelancers";
      }
    });
  }

  function sendSmsInvite(phone, user) {
    $.ajax({
      url: "/ajax/sendSmsInvite",
      type: "POST",
      data: {
        YII_CSRF_TOKEN: token,
        phone: phone,
        user: user,
      },
    }).done(function (response) {
      response = JSON.parse(response);

      if (response.code == 0) {
        if (response.response.length) {
          location.href = response.response;
        } else {
          location.href = "/freelancers";
        }
      } else {
        let error =
          response.response !== undefined &&
          response.response.error !== undefined
            ? response.response.error
            : response.text;

        $(".errors").text(error);
        $(".errors").removeClass("hddn");
      }
    });
  }

  var sendInviteClicked = false;
  $("#send_invite").on("click", function () {
    if (sendInviteClicked != true) {
      sendInviteClicked = true;

      let phone = $("#invite_phone").val();
      let note = $("#invite_note").val();
      let customer = $("#customer").val();
      let inEnglish = $("#in_english:checked").val();
      let managerIds = $('#select-managers').val();

      $(".empty_customer").addClass("hddn");
      $(".empty_phone").addClass("hddn");
      $(".incorrect_phone").addClass("hddn");

      if (phone.length == 0) {
        $(".empty_phone").removeClass("hddn");
      } else {
        $(".empty_phone").addClass("hddn");

        if (!isValidEmail(phone)) {
          $(".incorrect_phone").removeClass("hddn");
        } else {
          $(".incorrect_phone").addClass("hddn");

          if (customer.length == 0) {
            $(".empty_customer").removeClass("hddn");
          } else {
            $(".empty_customer").addClass("hddn");
            if (showLoader($(this))) {
              sendInvitePhone(phone, customer, false, inEnglish, note, managerIds);
              return;
            }
          }
        }
      }

      sendInviteClicked = false;
    }
  });

  $(".reply_invite_by_sms").on("click", function () {
    let user = $(this).data("user");
    $("#phoneRequestModal #sms-send-to-user").val(user);
    $("#phoneRequestModal").modal("show");
  });

  let sendSmsInviteClicked = false;
  $("#send_invite_by_sms").on("click", function () {
    if (sendSmsInviteClicked !== true) {
      sendSmsInviteClicked = true;

      let phone = $("#phone-request").val().replace(/\s/g, "");
      let user = $("#sms-send-to-user").val();
      if (phone.length === 0 || !isValidPhone(phone)) {
        $(".errors").text($(".errors").data("default"));
        $(".errors").removeClass("hddn");
      } else {
        $(".errors").addClass("hddn");
        if (showLoader($(this))) {
          sendSmsInvite(phone.replace(/\D/g, ""), user);
          return;
        }
      }

      sendSmsInviteClicked = false;
    }
  });

  $("body").on("click", ".reply_invite", function (event) {
    event.preventDefault();

    var user_id = $(this).data("user");

    showLoader($(this));

    $.ajax({
      url: "/ajax/resendInvite",
      type: "POST",
      data: {
        user: user_id,
        YII_CSRF_TOKEN: token,
      },
    }).done(function (response) {
      response = JSON.parse(response);
      if (response.response.length) {
        location.href = response.response;
      } else {
        location.href = "/freelancers";
      }
    });
  });

  $(".balance-up").on("click", function () {
    var balance_id = $(this).data("balance");

    $("#balance-up-modal .fade.in").removeClass("in");
    $(".modal-backdrop").remove();
    $("body").removeClass("modal-open");

    $.ajax({
      url: "/ajax/getBalanceUpModalWindow",
      type: "POST",
      data: {
        YII_CSRF_TOKEN: token,
        balance: balance_id,
      },
    }).done(function (response) {
      response = JSON.parse(response);
      if (response.code == 0) {
        $("#balance-up-modal").html(response.response);

        $("#balance-up-dialog").modal();
      }
    });
  });

  $("#balance-up-modal").on("keyup", ".amount", function () {
    calculateInvoiceCost();
  });

  $('#balance-up-modal ').on('click', '.js-payment-type', function () {
    calculateInvoiceCost();
  })

  function calculateInvoiceCost() {
    const $amount = $("#amount");
    const $form = $("#balance-up-modal").find('form');

    let amount = isNaN(parseFloat($amount.val())) ? 0 : parseFloat($amount.val())
    if ( amount === 0) {
      $form.find('.js-total-amount').text("0");
      $form.find('.js-vat').text("0");
      $form.find('.js-commission-wrap').hide();
      return
    }

    $(".up-error")
        .addClass("hddn");

    let payload = $('#topup_balance').serializeArray();
    payload.push({
      name: "YII_CSRF_TOKEN",
      value: token
    })

    $.ajax({
      url: "/files/invoiceCost",
      method: "POST",
      data: payload,
      success: function(data) {
        data = JSON.parse(data);
        if (data.code === 0) {
          $form.find('.js-total-amount').text(data.response.totalAmount + " " + data.response.currencyIcon);
          $form.find('.js-vat').text(data.response.vat + " " + data.response.currencyIcon);

          if (data.response.commission > 0) {
            $form.find('.js-commission-wrap').show();
            $form.find('.js-commission').text(
                data.response.commission + " " + data.response.currencyIcon + " (" + data.response.commissionPercent + "%)");
          } else {
            $form.find('.js-commission-wrap').hide();
          }
        } else {
          $form.find('.js-total-amount').text("0");
          $form.find('.js-vat').text("0");
          $(".up-error")
              .removeClass("hddn")
              .find(".error-description")
              .text(data.response);
        }
      }
    })
  }

  const onBalanceUpContinue = (isSuccess) => {
    const data = $('#topup_balance').serializeArray();
    const currency = data.find(el => el.name === 'currency').value;
    const payment_type = data.find(el => el.name === 'payment_type').value;
    let currencyAsStr;
    switch(currency) {
      case '1':
        currencyAsStr = 'rub';
        break;
      case '2':
        currencyAsStr = 'usd';
        break;
      default:
        currencyAsStr = 'eur';
        break;
    }
    const userIdEl = document.getElementById('userId');
    const userId = userIdEl ? userIdEl.content : '0';
    try {
      window.dataLayer.push({
        event: 'balance_topup',
        status: isSuccess ? 'success' : 'closed',
        currency: currencyAsStr,
        payment_method: payment_type,
        user_id: userId,
      });
    } catch (_) {}
  };

  $("#balance-up-modal").on("click", ".js-balance-up-button", function () {
    $(".up-error").addClass("hddn");

    let payload = $('#topup_balance').serializeArray(),
        $this = $(this);

    payload.push({
      name: "YII_CSRF_TOKEN",
      value: token
    })

    $.ajax({
      url: "/files/generateInvoice",
      type: "POST",
      data: payload,
      beforeSend: () => {
        $this.attr({disabled: true});
      },
      complete: () => {
        $this.attr({disabled: false});
      },
    }).done(function (response) {
      response = JSON.parse(response);
      onBalanceUpContinue(response.code == 0);
      if (response.code == 0) {
        if (response.response.redirectUrl) {
          location.href = response.response.redirectUrl;
        } else {
          documentStatusWidget("#invoice", [response.response.fileId]).done(function (
              file_id
          ) {
            $("#balance-up-modal .fade.in").removeClass("in");
            $(".modal-backdrop").remove();
            $("body").removeClass("modal-open");
            location.href = "/files/getFile/?id=" + file_id[0];
          });
        }
      } else {
        $(".up-error")
          .removeClass("hddn")
          .find(".error-description")
          .text(response.response);
      }
    });
  });

  function format(d, count) {
    let compensationAmount = typeof d.compensationAmount !== "undefined" ? d.compensationAmount : 0;

    var html = '<tr><td colspan="' + count + '">';

    html +=
      '<table class="table table-hover table-detail">' +
      "<tr>" +
      '<td style="width:120px">' +
      translate.task_title +
      ":</td>" +
      "<td>" +
      d.title +
      "</td>" +
      "</tr>" +
      "<tr>" +
      "<td>" +
      translate.task_description +
      ":</td>" +
      '<td class="editor-style">' +
      d.description +
      "</td>" +
      "</tr>";

    if (d.mtxid != undefined) {
      html +=
        "<tr>" +
        '<td style="width:120px">Merchant TxId:</td>' +
        "<td>" +
        (d.mtxid != undefined ? d.mtxid : "-") +
        "</td>" +
        "</tr>";
    }

    if (d.pmethod != undefined) {
      html +=
        "<tr>" +
        '<td style="width:120px">Payout Method:</td>' +
        "<td>" +
        (d.pmethod != undefined ? d.pmethod : "-") +
        "</td>" +
        "</tr>";
    }

    if (typeof d.group !== "undefined") {
      html +=
        "<tr>" +
        "<td>" +
        translate.task_groups +
        ":</td>" +
        "<td>" +
        d.group +
        "</td>" +
        "</tr>";
    }

    html +=
      "<tr>" +
        (d.created !== undefined ?
      "<td>" +
      translate.date_created +
      ":</td>" +
      "<td><strong>" +
      d.created +
      "</strong></td>" : '') +
      "</tr>" +
      "<tr>" +
      "<td>" +
      translate.date_paid +
      ":</td>" +
      "<td><strong>" +
      d.paid +
      "</strong></td>" +
      "</tr>" +
      "<tr>" +
      "<td>" +
      translate.task_manager +
      ":</td>" +
      "<td>" +
      d.manager +
      "</td>" +
      "</tr>" +
      "<tr>" +
      "<td>" +
      translate.task_worker +
      ":</td>" +
      "<td>" +
      d.worker +
      "</td>" +
      "</tr>";

    if (d.payer != undefined) {
      html +=
        "<tr>" +
        "<td>" +
        translate.task_payer +
        ":</td>" +
        "<td>" +
        d.payer +
        "</td>" +
        "</tr>" +
        "<tr>";
    }

    if (typeof d.sum !== "undefined") {
      html +=
        "<td>" +
        translate.sum_all +
        ":</td>" +
        '<td><i class="txt-color-blueLight">' +
        d.sum +
        "</i></td>" +
        "</tr>";
    }

    if (compensationAmount) {
      const parsedAmount = compensationAmount.replaceAll('>','<').split('<');
      let hasAmountMoreThanZero = false;
      parsedAmount.map(el => hasAmountMoreThanZero = hasAmountMoreThanZero || (!!parseFloat(el)));
      let percentText = '';
      if (hasAmountMoreThanZero) {
        const currencyText = d.currency === '₽' ? 'rub' : (d.currency === '€' ? 'eur' : 'usd');
        percentText = d.compensationPercent > 0 ? ` • ${d.compensationPercent}%` : (' ' + translate[`small_compensation_${currencyText}`]);
      }

      html +=
        "<td>" +
        translate.compensationAmount +
        ":</td>" +
        '<td><i class="txt-color-blueLight">' + compensationAmount + percentText + "</i></td>" +
        "</tr>";
    }

    if (typeof d.advCommissionAmount !== "undefined") {
      html +=
          "<td>" +
          translate.advCommissionAmount +
          ":</td>" +
          '<td><i class="txt-color-blueLight">' +
          d.advCommissionAmount +
          "</i></td>" +
          "</tr>";
    }

    if (typeof d.amount !== "undefined") {
      html +=
        "<td>" +
        translate.amount +
        ":</td>" +
        '<td><i class="txt-color-blueLight">' +
        d.amount +
        "</i></td>" +
        "</tr>";
    }

    if (d.damage) {
      html +=
        '<td><span class="damage-table">' +
        translate.damage +
        "</span></td>" +
        "<td>" +
        d.damage +
        "</td>" +
        "</tr>";
    }

    if (d.acceptanceFiles) {
      html +=
          '<td><span>' +
          translate.acceptanceFiles +
          "</span></td>" +
          "<td>" +
          d.acceptanceFiles +
          "</td>" +
          "</tr>";
    }

    html += "</table></td></tr>";

    return html;
  }

  $("#elements-main").on("click", ".task-collapse", function (event) {
    event.preventDefault();

    let that = $(this);
    let item = $(this).parents("tr");
    let tr = $(this).closest("tr");

    let data = {
      title: item.data("title"),
      description: item.data("description"),
      created: item.data("created"),
      paid: item.data("paid"),
      manager: item.data("manager"),
      payer: item.data("payer"),
      sum: item.data("sum"),
      amount: item.data("amount"),
      group: item.data("group"),
      mtxid: item.data("merchant-txid"),
      pmethod: item.data("payout-method"),
      worker: item.data("worker"),
      damage: item.data("damage"),
      acceptanceFiles: item.data("acceptance-files"),
      compensationAmount: item.data("compensation-amount"),
      compensationPercent: item.data("compensation-percent"),
      currency: item.data("currency"),
      advCommissionAmount: item.data('adv_commission_amount')
    };

    if (that.find("i").hasClass("fa-minus-circle")) {
      // This row is already open - close it
      tr.next("tr").remove();
      tr.removeClass("shown");
      that.find("i").removeClass("fa-minus-circle").addClass("fa-plus-circle");
    } else {
      // Open this row
      tr.after(format(data, tr.find("td").length));
      tr.addClass("shown");
      that.find("i").removeClass("fa-plus-circle").addClass("fa-minus-circle");
    }
  });

  $("#elements-main").on("click", ".row-collapse-link", function (event) {
    event.preventDefault();
    let that = $(this);
    let tr = $(this).closest("tr");

    if (that.find("i").hasClass("fa-minus")) {
      tr.next("tr").hide();
      tr.removeClass("shown");
      that.find("i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      tr.next("tr").show();
      tr.addClass("shown");
      that.find("i").removeClass("fa-plus").addClass("fa-minus");
    }
  });

  $("#elements-main, #main-freelancer").on("click", ".sr-row-collapse-link", function (event) {
    event.preventDefault();
    let that = $(this);
    let tr = $(this).closest("tr");

    if (that.find("i").hasClass("fa-minus")) {
      tr.next("tr").hide();
      tr.removeClass("shown");
      that.find("i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      tr.next("tr").show();
      tr.addClass("shown");
      that.find("i").removeClass("fa-plus").addClass("fa-minus");
    }
  });

  $("body").on("click", ".cur_btn", function (e) {
    e.preventDefault();
    $("#currency").val($(this).data("id"));
    $("#main_cur_btn").text($(this).text());
    calculateInvoiceCost();
  });

  $(".select_checkboxes").on("click", function () {
    var target = $(this).data("target");
    var isChecked = $(this).prop("checked");

    if (isChecked) {
      $("input[type=checkbox]." + target + ":not(:checked)").trigger("click");
    } else {
      $("input[type=checkbox]." + target + ":checked").trigger("click");
    }
  });

  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\#&]" + name),
      results = regex.exec(location.hash);
    return results === null ? false : true;
  }

  $("body").on("click", "[data-copy-text]", function (e) {
    e.preventDefault();
    var text = $(this).data("copy-text");
    window.prompt(translate.copy_text_title, text);
  });

  //Импорт задач и фрилов в ЛК заказчика
  $("#import-file-form .btn-primary").on("click", function () {
    if (!$(this).hasClass("disabled")) {
      $("#import-file-form").trigger("submit");
    }
    $(this).addClass("disabled");
    $(this).attr("disabled", true);
  });

  //Загрузка файлов задачи
  // $('#edit-task-form .btn-primary').click(
  //   function() {
  //     if (!$(this).hasClass('disabled')) {
  //       $('#edit-task-form').submit();
  //     }
  //     $(this).addClass('disabled');
  //   }
  // );

  //Загрузка документов в профиле фрила
  $("#idDocumentForm .btn-primary").on("click", function () {
    if (!$(this).hasClass("disabled")) {
      $("#idDocumentForm").trigger("submit");
    }
    $(this).addClass("disabled");
  });

  $('input[type="checkbox"][data-toggle-button]').on(
    "change",
    function (event) {
      var $el = $(this);
      if ($el.prop("checked")) {
        $($el.attr("data-toggle-button")).each(function () {
          $(this)
            .prop("disabled", "")
            .removeClass("btn-default")
            .addClass("btn-success");
        });
      } else {
        $($el.attr("data-toggle-button")).each(function () {
          $(this)
            .prop("disabled", "disabled")
            .addClass("btn-default")
            .removeClass("btn-success");
        });
      }
    }
  );

  $("#upgrade-first-form #continue-button").on("click", function (event) {
    var $el = $(this);

    if ($el.prop("disabled")) {
      return;
    }

    var val = $('input[name="go"]:checked', "#upgrade-first-form").val();

    if (val != 1) {
      event.preventDefault();
      document.location.href = $("#upgrade-first-form").attr("action");
      return false;
    }
  });

  if ($(".table-wrap").length) {
    $(".table-wrap").each(function () {
      var nmtTable = $(this);
      var nmtHeadRow = nmtTable.find("thead tr");

      nmtTable.find("tbody tr").each(function () {
        var curRow = $(this);
        for (var i = 0; i < curRow.find("td").length; i++) {
          var rowSelector = "td:eq(" + i + ")";
          var headSelector = "th:eq(" + i + ")";
          curRow
            .find(rowSelector)
            .attr("data-title", nmtHeadRow.find(headSelector).text());
        }
      });
    });
  }

  if ($('[data-toggle="tooltip"]').length) {
    $('[data-toggle="tooltip"]').tooltip();
  }

  // you can use only 2 classes .sr-box-trigger for trigger and .dynamic-hidden for hidden cells
  $("#elements-content").on("click", ".sr-box-trigger", function (e) {
    e.preventDefault();
    const thisParentTd = $(this).parents("tr");
    const sb = $(this).parent().siblings(".dynamic-hidden");

    const hiddenCells = Array.from(sb).map(function (it) {
      return `<div class="list-item">${it.innerHTML}</div>`;
    });

    const joinArrData = hiddenCells.join("");

    const siblingsLength = $(this).parent("td").siblings().length + 1;

    const data = `<tr class="dynamic-box"><td colspan=${siblingsLength}>${joinArrData}</td></tr>`;

    thisParentTd.toggleClass("opened");

    if (thisParentTd.hasClass("opened")) {
      $(this)
        .children()
        .removeClass("fa-plus-circle")
        .addClass("fa-minus-circle");
      thisParentTd.after(data);
    } else {
      $(this)
        .children()
        .removeClass("fa-minus-circle")
        .addClass("fa-plus-circle");
      thisParentTd.next().remove();
    }
  });

  if ($(".meta-toggle").length) {
    $(".meta-toggle").on("click", function (e) {
      e.preventDefault();

      $("meta[name=HandheldFriendly], meta[name=MobileOptimized]").remove();
      $("meta[name=viewport]").attr(
        "content",
        "width=1280, initial-scale=1.0,user-scalable=yes"
      );
    });
  }

  function setHeight(aside) {
    const asideEl = $(aside);
    if (!asideEl.length) {
      return;
    }

    let asidePosition = asideEl.position().top;
    let calcHeight = $(window).height() - asidePosition;

    asideEl.height(calcHeight);
  }

  function sidebarHeightSetter(aside = "#left-panel-nav") {
    if (aside.length) {
      setHeight(aside);

      $(window).on("resize", () => setHeight(aside));
      $("#left-panel .login-info").on("resize", () => setHeight(aside));
    }
  }

  sidebarHeightSetter();

  function onTaskMenuClick(type) {
    const userIdEl = document.getElementById('userId');
    const userId = userIdEl ? userIdEl.content : '0';
    try {
      window.dataLayer.push({ event: 'tasks_task_status', status_name: type, user_id: userId });
    } catch (_) {}
  }

  $('#MenuItemTasksAll').on("click", ()=>{
    onTaskMenuClick('All');
  })
  $('#MenuItemTasksPendingAcceptance').on("click", ()=>{
    onTaskMenuClick('Pending acceptance');
  })
  $( '#MenuItemTasksPendingPayment').on("click", ()=>{
    onTaskMenuClick('Pending payment');
  })
  $('#MenuItemTasksCompleted').on("click", ()=>{
    onTaskMenuClick('Completed');
  })
});

//Serializator
window.serialize = function (form) {
  var serialized = [];
  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i];
    if (
      !field.name ||
      field.disabled ||
      field.type === "file" ||
      field.type === "reset" ||
      field.type === "submit" ||
      field.type === "button"
    )
      continue;
    if (field.type === "select-multiple") {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(
          encodeURIComponent(field.name) +
            "=" +
            encodeURIComponent(field.options[n].value)
        );
      }
    } else if (
      (field.type !== "checkbox" && field.type !== "radio") ||
      field.checked
    ) {
      serialized.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
    }
  }

  return serialized.join("&");
};

/**
 * Show loader and checks in background if document is ready
 * @param selector - css selector for element where loading and download are shown
 * @param document_id
 * @param redirect
 */
function documentStatusWidget(selector, file_ids) {
  var dfd = jQuery.Deferred();
  // add loader
  $(selector).unbind();
  $(selector).html(
    '<i class="fa fa-refresh fa-spin fa-1x fa-fw"></i> ' +
      translate.generating_document
  );
  $(selector).show();

  getDocumentStatus(file_ids)
    .done(function (file_ids) {
      dfd.resolve(file_ids);
    })
    .fail(function (response) {
      dfd.reject(response);
    });

  return dfd.promise();
}

function getDocumentStatus(file_ids) {
  var dfd = jQuery.Deferred();
  $.post(
    "/ajax/getdocumentstatus",
    {
      YII_CSRF_TOKEN: token,
      file_ids: file_ids,
    },
    function (response) {
      var response = JSON.parse(response);
      if (response.code == 0) {
        dfd.resolve(response.response);
      } else {
        var currentInstance = this;
        setTimeout(function () {
          $.ajax(currentInstance);
        }, 1000);
      }
    }
  ).fail(function (response) {
    dfd.reject(response);
  });

  return dfd.promise();
}

/**
 * Sleep for certain time in ms with a promise
 * @param time
 * @returns {boolean}
 */
function sleep(time) {
  return new Promise((resolve = setTimeout(resolve, time)));
}

/**
 * Function to format numbers with separators between thousands and delimiters
 * Similar to PHP function number_format
 * @param decimals
 * @param dec_separator
 * @param thousand_separator
 * @returns {string}
 */
Number.prototype.formatMoney = function (
  decimals,
  dec_separator,
  thousand_separator
) {
  var number = this,
    decimals = isNaN((decimals = Math.abs(decimals))) ? 2 : decimals,
    dec_separator = dec_separator == undefined ? "," : dec_separator,
    thousand_separator =
      thousand_separator == undefined ? " " : thousand_separator,
    s = number < 0 ? "-" : "",
    i = parseInt((number = Math.abs(+number || 0).toFixed(decimals))) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + thousand_separator : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand_separator) +
    (decimals
      ? dec_separator +
        Math.abs(number - i)
          .toFixed(decimals)
          .slice(2)
      : "")
  );
};
